import { CloudDownloadOutlined } from '@ant-design/icons';
import { useDownloadFile } from 'shared/hooks/use-download-file';
import { useGetCargoDocumentLink } from 'client-app/api/documents/use-get-cargo-document-link';
import type { IDocumentDownloadButtonProps } from './types';

export const DocumentDownloadButton: React.FC<IDocumentDownloadButtonProps> = ({ documentId }) => {
  const downloadFile = useDownloadFile();
  const { mutateAsync: downloadDocument } = useGetCargoDocumentLink();

  const handleClick = async () => {
    const result = await downloadDocument({ documentId });
    if (result) {
      downloadFile(result?.url);
    }
  };

  return <CloudDownloadOutlined className='hover' style={{ fontSize: 20 }} onClick={handleClick} />;
};
